import { createContext, useContext, useState, useEffect } from 'react';
import Pusher from 'pusher-js';
import {useDispatch} from "react-redux";
import {fetchChats} from "../app/store/slices/chat/effects";

const PusherContext = createContext();

export const usePusher = () => {
    return useContext(PusherContext);
};

export const PusherProvider = ({ children }) => {
    const [channel, setChannel] = useState(null);
    const [message, setMessage] = useState('')

    useEffect(() => {
        const pusher = new Pusher(`${process.env.PUSHER_APP_ID}`, {
            cluster: 'us2',
        });

        const channel = pusher.subscribe('chat-admin');
        setChannel(channel);

        return () => {
            channel.unbind_all();
            channel.unsubscribe();
        };
    }, []);

    return (
        <PusherContext.Provider value={{channel, message, setMessage}}>
            {children}
        </PusherContext.Provider>
    );
};
